import * as yup from 'yup'
import { TDeadline } from '@/interfaces/offer'
import { TServiceQuestionType } from '@/interfaces/service-question'

export const commonSchema = yup.object({
  _serviceCategoryId: yup.string().required('サービスを選択してください'),
  deadline: yup
    .mixed<TDeadline>()
    .oneOf(Object.values(TDeadline), '希望納期を選択してください')
    .required('希望納期を選択してください'),
  budget: yup
    .number()
    .transform((value) => (isNaN(value) ? null : value))
    .nullable()
    .optional(),
  _files: yup
    .array()
    .of(
      yup.object().shape({
        url: yup.string().required(),
        name: yup.string().required(),
      }),
    )
    .optional(),
  answers: yup
    .array()
    .of(yup.object().shape({
      questionId: yup.string().required(),
      label: yup.string().required(),
      type: yup.mixed<TServiceQuestionType>().oneOf(Object.values(TServiceQuestionType)).required(),
      value: yup.string().optional(),
      files: yup
        .array()
        .of(yup.object().shape({
          url: yup.string().required(),
          name: yup.string().required(),
        }))
        .optional(),
    }))
    .optional(),
})

export const decidedSchema = yup.object({
  title: yup.string().required('ご相談内容を入力してください'),
  description: yup.string().required('内容詳細を入力してください'),
})

export const undecidedSchema = yup.object({
  keyword: yup.string().optional(),
  title: yup
    .string()
    .defined()
    .test('title-required', 'ご相談内容を入力してください', function (value) {
      const description = (this.parent as { description?: string } | undefined)
        ?.description?.trim()
      // 片方だけ空のときに該当フィールドへエラー表示。両方空は object-level test 側で扱う
      if (!value?.trim() && description) return false
      return true
    }),
  description: yup
    .string()
    .defined()
    .test('description-required', '内容詳細を入力してください', function (value) {
      const title = (this.parent as { title?: string } | undefined)
        ?.title?.trim()
      if (!value?.trim() && title) return false
      return true
    }),
}).test('require-content', '', function (values) {
  const title = values?.title?.trim() || ''
  const description = values?.description?.trim() || ''

  // 生成前 (両方空) → keyword 入力欄にエラー表示
  if (!title && !description) {
    return this.createError({
      path: 'keyword',
      message: '5文字以上で依頼内容を入力し、依頼内容を生成してください',
    })
  }
  return true
})

export type CommonSchema = yup.InferType<typeof commonSchema>
export type DecidedSchema = yup.InferType<typeof decidedSchema>
export type UndecidedSchema = yup.InferType<typeof undecidedSchema>

export const DESCRIPTION_PLACEHOLDER = `この度、新曲「曲名」のミックスマスタリングをお願いしたく、ご連絡いたしました。

【楽曲情報】
・ジャンル：〇〇
・テンポ：〇〇BPM
・尺：〇分〇秒
・使用DAW：〇〇
・ファイル形式：WAV（〇〇kHz/〇〇bit）
・トラック数：〇〇トラック（内訳：ドラム〇トラック、ベース〇トラック、ギター〇トラック、キーボード〇トラック、ボーカル〇トラック）`
